import { gql } from '@apollo/client';

export const BRANCH = gql`
    query {
        branchesProvider {
            tradename
            id
            name
            score
            studio{
                id
                score
                tradeName
            }
			teacher_changes
        }
    }
`;

export const BILLING_BRANCH = gql`
    query ($idBranch:Int, $month: String, $year: String, $isByYear: Boolean){
		BillingReportByBranch(idBranch: $idBranch, month:$month, year:$year, isByYear:$isByYear){
			success
			message
			billing{
				id      
				id_branch
				year
				month
				totalTook
				totalShow
				totalLate
				totalAssistance
				total_Teacher
				feeTook
				feeLate
				feeShow
				no_assistance
				iva
				total
				createdDatetime
				virtual
				calendars_by_branch
			}		
	    }		
	}
`;

export const CLASSES_BRANCH = gql`
query ($branchId:Int!,$date:String!,$searchTerm: String, $startTime: String, $endTime: String, $inscribedFrom: Int, $page: Int, $perPage: Int ){
	classesDayByBranchIdPaginate(branchId:$branchId,date:$date,term: $searchTerm, startTime: $startTime, endTime: $endTime, inscribedFrom: $inscribedFrom, page: $page, perPage: $perPage){
		total
		per_page
		current_page
		from
		to
		last_page
		has_more_pages
		data{
			id
			start
			end
			availableSpace
			capacity
			enabled
			closedCalendars
			lateCancel
			hasReservationCancel
			studio{
				fee
				lateFee
			}
			classFit{
				id
				name
				branch{
					id
					host_admin
				}
				fitType{
					id
					newImageUrl
					imageUrlClassType
				}
				virtual
				teacher{
					image_teacher
				}
				url_image
			}
			virtualClass{
				id
				zoom_id
				zoom_link
				zoom_host_link
			}
			requestQuota{
				id
				calendarId
				userId
				newAvailableSpace
				createdAt
			}
			cancelClass{
				calendarId
				reasonCancelation
				createdAt
			}
			reservations{
				statusId
			}
		}
	}
}
`

export const CLASSES_BRANCH_TOTAL = gql`
	query (
		$branchId: Int!,
		$date: String!,
		$searchTerm: String,
		$startTime: String,
		$endTime: String,
		$inscribedFrom: Int,
		$page: Int,
		$perPage: Int
	){
		classesDayByBranchIdPaginate(
			branchId: $branchId,
			date: $date,
			term: $searchTerm,
			startTime: $startTime,
			endTime: $endTime,
			inscribedFrom: $inscribedFrom,
			page: $page, 
			perPage: $perPage
		){
			total
			data {
				id
				capacity
			}
		}
	}
`

export const RESERVES_BY_CALENDAR = gql`
	query ($calendarId:Int!){
		reservationsByCalendar(calendarId:$calendarId){
			id
			user{
				id
				names
				surnames
			}
			status{
				id
				name
			}
			
			calendar{
				id
				start
				classFit{
					id
					name
					virtual
				}
			}
		}
	}
`;

export const RESERVES_BRANCH = gql`
	query ($idBranch:Int!,$start:String!,$end:String!,$status:[Int]!,$page:Int!){
		reservesBranch(branch_id:$idBranch,start:$start,end:$end,current_page:$page,status:$status){
			data{
				id
				start
				end
				virtualClass{
					id
					zoom_id
					zoom_link
					zoom_host_link
				}
				classFit{
					id
					name
					fitType{
						id
						newImageUrl
					}
					branch {
						id
						host_admin
					}
				}
			}
		}
	}
`;

export const CLASSES_TAKEN = gql`
	query ($branchId:Int!, $date:String!, $classIds : [Int], $day: Int, $hour:String){
		classByMonthProvider(branchId:$branchId,date:$date,classIds:$classIds,day:$day,hour:$hour){
			success
			message
			data{
				taked
				noShow
				canceled
				lateCancel
				total
				totalValue
				calendar{
					id
					start
					price
					classFit{
					id
					name
					}
				}
			}
		}
    }
`;

export const GENERATE_QR = gql`
	query($branchId: Int!) {
		QrGenerate(branchId: $branchId,mode: "black") {
			success
			message
		}
	}
`;

export const CLASS_TYPES = gql`
	query ($isByRating: Boolean, $idBranch: Int){
		classTypes(isByRating: $isByRating, idBranch: $idBranch) {
			data{
				id
				name
			}		
		}
	}
`;

export const CHECK_BRANCH_NATURAL_PERSON = gql`
	query($branchId: Int!){
		checkBranchNaturalPerson(branchId: $branchId){
			success
			message
		}
	}
`;

export const BRANCH_BY_ID = gql`
    query($branchId: Int!) {
		branch(id:$branchId){
			id
			name
			tradename
		}
    }
`;

export const BRANCH_COMMENTS = gql`
	query ($idBranch:Int!, $page: Int, $perPage: Int, $idClassType: String){
		newComments(idBranch:$idBranch, page: $page, perPage: $perPage, idClassType: $idClassType){
			total
			has_more_pages
			current_page
			data {
				id
				total
				comments
				classType
				created				
			}
		}
	}
`;

export const CLASS_BY_BRANCH = gql`
	query($term: String,$branchId:Int!) {
		classes(term: $term,branch_id:$branchId, enable: true) {
			id
			name
			enabled
			branch{
				id
				name
				nit
			}
		}
	}
`;

export const ADD_CLOSE_QUOTAS = gql`
	mutation ($userId:Int , $calendarId:Int! ,$close: Boolean!,$quotas:Int, $type:String, $requiresValidation:Boolean){
		AddAndCloseQuotas(userId:$userId , calendarId:$calendarId, close:$close, quotas:$quotas, type:$type, requiresValidation:$requiresValidation){
			success
			message
        }
}`;

export const CREATE_CANCEL_CLASS = gql`
	mutation ($userId:Int , $calendarId:Int! ,$reasonCancelation: String!,$supports:[String], $studioId:Int){
		cancelClass(userId:$userId , calendarId:$calendarId, reasonCancelation:$reasonCancelation, supports:$supports, studioId:$studioId){
			success
			message
        }
}`;

export const ADD_CLOSE_QUOTAS_MASSIVE = gql`
	mutation ($userId:Int, $calendarIds:[Int]!, $close: Boolean!, $quotas:[Int]!){
		AddAndCloseQuotasMassive(userId:$userId , calendarIds:$calendarIds, close:$close, quotas:$quotas){
			success
			message
        }
}`;

export const CREATE_REQUEST_QUOTAS = gql`
	mutation ($userId:Int, $calendarId:Int!, $newAvailableSpace:Int!){
		createRequestQuota(userId:$userId , calendarId:$calendarId, newAvailableSpace:$newAvailableSpace){			
			success
			message
		}
}`;

export const ATTENDANCE_TAKED = gql`
	mutation ($bookId:Int!,$idCardUser:String!,$originWeb: Boolean!){
		attendanceClassStudio(bookId:$bookId , idCardUser:$idCardUser, originWeb:$originWeb){
			success
			message
		}
	}
`;

export const UPDATE_CALENDAR = gql`
	mutation($calendar: CalendarUpdateInputTeacherType!) {
		updateCalendarMutationTeacher(calendar: $calendar) {
			success
			message
		}
	}
`;

export const SAVE_RESPONSE_BRANCH = gql`
	mutation ($branchId:Int!, $answer: Boolean!){
		saveReponseBranch(branchId:$branchId , answer:$answer){
			success
			message
		}
	}
`;

export const GET_HOST_LINK = gql`
	query($id: Int!) {
		getMeetingByIdZoom(id: $id) {
			id
			zoom_id
			zoom_link
			zoom_host_link
		}
	}
`;

export const MODIFY_NAME_ZOOM = gql`
	query ($zoomId:String){
		modifyNameZoom(zoomId:$zoomId){
			success
			message
		}
	}
`;

export const GET_STUDIO = gql`
	query($id: Int!) {
		studio(id: $id) {			
			id		
			tradeName
			description
			imageUrl
		}
	}
`;

export const GET_STUDIO_BY_BRANCH = gql`
	query($id: Int!) {
		studioByBranch(id: $id) {			
			id		
			tradeName
			description
			imageUrl
		}
	}
`;


export const UPDATE_STUDIO = gql`
	mutation ($studioId:Int!, $imageBase:String, $description:String){
		updateStudio(
			studio: {
				studioId: $studioId
			  	imageBase: $imageBase
			  	description: $description
			}
		)	
		{			
			success
			message
		}
}`;

export const GET_CLASS_BY_ID = gql`
    query ($class_id: Int!) {
        classById(class_id: $class_id) {
            id
            name
            description
			description_html
			templates {
                id
                startTime
                endTime
                date_publication
                capacity
                day
                enabled
                more_one
                holidays
                __typename
            }
        }
    }
`;

export const UPDATE_CLASS_TEMPLATE = gql`
  mutation updateClassTemplate($classTemplate: [ClassTemplateUpdateInputType!]!) {
    updateClassTemplate(classTemplate: $classTemplate) {
      success
      message
    }
  }
`;


export const DELETE_CLASS_TEMPLATE = gql`
  mutation DeleteClassTemplate($classTemplateId: Int!) {
    deleteClassTemplate(classTemplateId: $classTemplateId) {
      success
      message
    }
  }
`;

export const UPDATE_CLASS_DESCRIPTION = gql`
  mutation UpdateClass($classId: Int!, $name: String, $description: String!, $description_html: String) {
    UpdateClass(class: {
      id: $classId,
      name: $name,
      description: $description
	  description_html: $description_html
    }) {
      success
      message
    }
  }
`;

export const GENERATE_CALENDARS = gql`
  mutation GenerateCalendars($studioId: Int, $branchId: Int, $classId: Int, $templateId: Int) {
    generateCalendars(studioId: $studioId, branchId: $branchId, classId: $classId, templateId: $templateId) {
      success
      message
    }
  }
`;



